import { render } from "./FiltreCustomer.vue?vue&type=template&id=56e88a24"
import script from "./FiltreCustomer.vue?vue&type=script&lang=ts"
export * from "./FiltreCustomer.vue?vue&type=script&lang=ts"
script.render = render

export default script